import { PayloadAction } from '@reduxjs/toolkit';
import * as actionTypes from 'domains/common/actionTypes';

export const setUserLocality = (locality: string): PayloadAction<String> => {
  return {
    type: actionTypes.DO_THING,
    payload: locality
  };
};
